/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Remove_Marker_LabelInputs */



/**
* | output |
* | --- |
* | "Remove selected marker" |
*
* @param {Markers_Remove_Marker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_remove_marker_label = /** @type {((inputs?: Markers_Remove_Marker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Remove_Marker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le marqueur selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Markierung entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi il marcatore selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить выбранный маркер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar el marcador seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除选定标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したマーカーを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित मार्कर को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover marcador selecionado")
	return /** @type {LocalizedString} */ ("Remove selected marker")
});